<!--suppress ALL -->
<template>
    <v-layout row wrap class="filter-ribbon">
        <v-flex xs12>
            <v-layout class="filter-ribbon__list">
                <v-flex xs12 v-if="filterRibbonList && filterRibbonList.length > 0">
                    <v-tabs
                            :class="activeTab === null ? 'bar-border' : ''"
                            v-model="activeTab"
                            color="white"
                            :mandatory="false"
                            hide-slider
                            mobile-break-point="600"
                    >
                        <v-tab v-for="filter in filterRibbonList"
                               :class="[
                                    filter.enabled ? '' : 'disabled-tab',
                                    (ribbonState[filter.key] && ribbonState[filter.key].length) ? 'bold-ribbon' : '',
                                    selectedRibbonFilter && selectedRibbonFilter.name === filter.name ? 'active-filter-tab' : ''
                                    ]"
                               @click.prevent="resetRibbon(filter)"
                               :data-qe-id="`filter_ribbon_tab_${filter.key}`"
                               :key="filter.key">
                            {{filter.name}}
                        </v-tab>
                        <v-tab-item
                                :transition="false"
                                :reverse-transition="false"
                                v-if="activeTab !== null"
                                v-for="(filterItem, index) in filterRibbonList"
                                :key="index"
                        >
                            <v-card flat>
                                <v-list class="list-frame">
                                    <v-flex xs12>
                                        <v-layout row wrap>
                                            <v-flex v-if="getRibbonTitle(filterItem.key)"
                                                    class="bold-font ypo_blue_color list-frame__title">
                                                {{getRibbonTitle(filterItem.key)}}
                                            </v-flex>
                                            <v-flex class="text-right">
                                                <v-btn flat
                                                       @click="cancel(filterItem.key)"
                                                       :data-qe-id="`member_directory_cancel_filter_for_${filterItem.key}`"
                                                       class="bold-font ypo_blue_color list-frame__button">
                                                    {{appCommonConstants.CANCEL}}
                                                </v-btn>
                                                <v-btn :disabled="noFilterData(filterItem.key)"
                                                       color="primary"
                                                       @click="apply(filterItem.key)"
                                                       :data-qe-id="`member_directory_apply_filter_for_${filterItem.key}`"
                                                       class="list-frame__button">
                                                    <span class="list-frame__button-label">{{appCommonConstants.APPLY}}</span>
                                                    <span v-if="newlySelectedFilterNumber">({{newlySelectedFilterNumber}})</span>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout>
                                           <filter-options :filter-item="filterItem" :selected-ribbon-filter="selectedRibbonFilter"></filter-options>
                                        </v-layout>
                                    </v-flex>
                                </v-list>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import {
        memberDirectoryPageConstant,
        createRibbonList,
        isButtonEnabled,
        ribbonTitles,
    } from '../memberDirectoryPage.constants';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { storeAction } from "../../../store/storeActions.constant";
    import { storeMutation } from "../../../store/storeMutations.constant";
    import { appCommonConstants, routerNames } from "../../appCommon.constants";
    import FilterOptions from "./FilterOptions";
    import MemberLocation from "./MemberLocation";
    import { trackEventConstant } from "../../../plugins/analytics.constant";

    export default {
        name: 'FilterRibbon',
        components: { FilterOptions, MemberLocation },
        data() {
            return {
                appCommonConstants,
                trackEventConstant,
                memberDirectoryPageConstant,
                showMoreToggled: false,
                currentComponent: '',
                contentClick: false,
                called: false,
                activeTab: null,
                selectedRibbonFilter: null,
            };
        },
        props: {
            memberDirectoryResult: {
                type: Object,
                required: true,
            },
            persistingFilterKey: {
                type: String,
                required: true,
            },
        },
        methods: {
            ...mapActions({
                getMemberDirectorySearchResults: `memberDirectory/${storeAction.getInitialMemberDirectorySearchResults}`,
            }),
            ...mapMutations({
                resetRibbonState: `memberDirectory/${storeMutation.resetRibbonState}`,
                clearRibbonState: `memberDirectory/${storeMutation.clearRibbonState}`,
                setRibbonWithRouteData: `memberDirectory/${storeMutation.setRibbonStateFromRouter}`,
                setSelectedTypeAhead: `memberDirectory/${storeMutation.setSelectedTypeAhead}`,
                setMemberDirectoryTypeAhead: `memberDirectory/${storeMutation.setMemberDirectoryTypeAhead}`,
            }),
            resetRibbon(filter) {
                this.selectedRibbonFilter = filter;
                this.resetRibbonState();
                if (filter && filter.filters && filter.filters.length === 1 && filter.filters[0].isTypeAhead) {
                    const typeAheadItem = filter.filters[0];
                    this.setMemberDirectoryTypeAhead(typeAheadItem.filterKey);
                    const activeTypeAhead =
                        this.typeAheadForMemberDirectory.find(item => item.key.toLowerCase() === typeAheadItem.filterKey.toLowerCase());
                    if (activeTypeAhead && activeTypeAhead.isActive) {
                        this.setSelectedTypeAhead({ parentKey: filter.key, activeTypeAhead });
                    } else {
                        this.setSelectedTypeAhead(null);
                    }
                }
                if (filter && filter.key === memberDirectoryPageConstant.constant.memberLocationKey) {
                    this.setMemberDirectoryTypeAhead(memberDirectoryPageConstant.constant.combinedCountryStateCityKey);
                    const activeTypeAhead =
                        this.typeAheadForMemberDirectory.find(item => item.key.toLowerCase() === memberDirectoryPageConstant.constant.combinedCountryStateCityKey.toLowerCase());
                    if (activeTypeAhead && activeTypeAhead.isActive) {
                        this.setSelectedTypeAhead({ parentKey: filter.key, activeTypeAhead });
                    } else {
                        this.setSelectedTypeAhead(null);
                    }
                }
            },
            cancel() {
                this.resetRibbonState();
                this.activeTab = null;
                this.selectedRibbonFilter = null;
            },
            apply() {
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        filters: JSON.stringify(this.ribbonState),
                        searchText: this.memberDirectorySearchText ? this.memberDirectorySearchText : '',
                    },
                });
                sessionStorage.setItem(this.persistingFilterKey, JSON.stringify(this.ribbonState));
                this.activeTab = null;
                this.selectedRibbonFilter = null;
                this.setSelectedTypeAhead(null);
            },
            getRibbonTitle(ribbonKey) {
                const ribbon = ribbonTitles.find(item => item.key === ribbonKey);
                if (ribbon) {
                    return ribbon.value;
                }
            },
            noFilterData(filterKey) {
                return isButtonEnabled(filterKey, this.ribbonState, this.selectedFilters);
            },
        },
        computed: {
            ...mapGetters({
                ribbonState: `memberDirectory/${storeGetters.ribbonState}`,
                selectedFilters: `memberDirectory/${storeGetters.selectedMemberDirectoryFilters}`,
                typeAheadForMemberDirectory: `memberDirectory/${storeGetters.typeAheadForMemberDirectory}`,
                memberDirectorySearchText: `memberDirectory/${storeGetters.memberDirectorySearchText}`,
            }),
            filterRibbonList() {
                if (this.memberDirectoryResult && this.memberDirectoryResult.searchRibbonGroup
                    && this.memberDirectoryResult.searchRibbonGroup.length > 0) {
                    const filteredRibbonItems = this.$route.name === routerNames.MEMBER_CONNECTIONS
                        ? this.memberDirectoryResult.searchRibbonGroup
                            .filter(item => item.key !== memberDirectoryPageConstant.constant.searchRibbonKeys.connections)
                        : [...this.memberDirectoryResult.searchRibbonGroup];
                    return createRibbonList(filteredRibbonItems, this.memberDirectoryResult.searchResults);
                }
            },
            newlySelectedFilterNumber() {
                const result = [];
                const { ribbonState, selectedFilters, selectedRibbonFilter } = this;
                if (ribbonState && selectedFilters && selectedRibbonFilter) {
                    const itemFromRs = ribbonState[selectedRibbonFilter.key];
                    const itemFromSf = selectedFilters[selectedRibbonFilter.key];

                    if (itemFromRs && itemFromSf) {
                       itemFromRs.forEach((rsItem) => {
                           const commonItem = itemFromSf.find(sfItem => (sfItem.label === rsItem.label && sfItem.filterKey === rsItem.filterKey));
                           if (!commonItem) {
                               result.push(rsItem);
                           }
                       });
                    }
                }
                return result.length > 0 ? result.length : null;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .filter-ribbon {
        background: $white;

        &__title {
            font-weight: 500;
            font-size: 14px !important;
            color: $black;
            letter-spacing: 0.29px;
            line-height: 24px;
            padding: 0px 15px 5px 0px;

            @include breakpoint(xs) {
                font-size: 12px !important;
            }
        }

        &__button {
            color: $ypo-cta;
            font-size: 16px;
            line-height: 37px;
            letter-spacing: 0.39px;
        }
    }

    .list-frame {
        background-color: $ypo-extra-light-gray;
        padding: 10px 20px 30px 10px;
        border: 1px solid $ypo-light-gray;
        margin-top: -2px;
        border-bottom-left-radius: 8px !important;
        border-bottom-right-radius: 8px !important;

        &__title {
            color: $ypo-blue;
            font-family: "Noto Sans", sans-serif;
            font-size: 14px;
            font-weight: bold;
            margin-top: 10px;
            letter-spacing: 0.23px;
            line-height: 24px;

            @include breakpoint(sm) {
                margin-top: 0;
            }
        }

        &__button {
            &-label {
                margin-right: 3px;
            }
        }

        &__actions {
            position: absolute;
            right: 15px;
            top: 5px;

        }
    }

    .bold-ribbon {
        color: $ypo-blue;
        font-weight: 600;
    }

    .bar-border {
        border-bottom: 1px solid $ypo-tile-border !important;

    }
@media (max-width: 767px) {
    .filter-ribbon{
        &__title {
              padding: 10px 15px 5px 15px;
            }
    }
    .list-frame{
        &__actions {
            position: relative;
            right: inherit;
            top: inherit;

        }
    }
}
</style>

<style lang="scss">
    @import '../../../common/styles/_colors.scss';
    .filter-ribbon {

        .v-input--selection-controls.v-input .v-label {
            font-weight: 500;
        }

        &__list {
            .v-tabs {

                &__wrapper--show-arrows {
                    margin-left: 0;
                    margin-right: 0;
                }

                &__icon {
                    font-size: 34px;
                    margin-top: 1px;
                    height: 37px;
                    color: $ypo-cta;
                    font-weight: 600;
                    z-index: 100;
                    background-color: $white !important;

                    &--prev {
                        margin-left: -5px;
                    }

                    &--next {
                        margin-right: -5px;
                    }
                }

                &__div {
                    max-width: none;
                }

                &__bar {
                    z-index: 2;

                    .v-icon {
                        top: 10px;
                    }
                }

                .disabled-tab {

                    .v-tabs__item {
                        pointer-events: none;
                        color: $ypo-medium-gray !important;
                    }
                }

                &__item {
                    text-transform: none;
                    color: $ypo-cta;
                    font-size: 14px;
                    opacity: 1 !important;
                    z-index: 2;
                    padding: 10px 15px 0;

                    &--active {
                        background-color: $ypo-extra-light-gray;
                        border-top: 1px solid $ypo-light-gray;
                        border-right: 1px solid $ypo-light-gray;
                        border-left: 1px solid $ypo-light-gray;
                        border-top-left-radius: 8px;
                        border-top-right-radius: 8px;
                    }
                }
            }
        }

        .list-frame__button {
            .v-btn__content {
                text-transform: none !important;
            }
        }
    }
</style>
